let items = [
    {
        id:0,
        name:"Apple iPad",
        description:"An iPad like no other",
        price: 329.00
    },
    {
        id: 1,
        name:"Apple iPad Pro",
        description:"Even more expensive than the iPad",
        price: 729.00
    }
]

export {items};